/**
 * A readable label for an event key the event lookup does not list (events only code attaches hooks to):
 * `CreateRequest:re_completed` reads "Create request re completed". English only: there is no translation for
 * these keys.
 */
export function humanizeEvent(event: string): string {
  const words = event
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .split(/[\s_.:-]+/)
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
